export default "__VITE_ASSET__CuDQl52K__"